// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";

class WorkFunctionObject {

	#companyId = null;
	#workFunctionId = null;
	#workFunctionName = null;
	#lastChanged = formatDate();
	#lastChangeAuthorId = null;

	constructor (props)
	{
		this.#companyId = props?.companyId || null;
		this.#workFunctionId = props?.id || props?.workFunctionId || null;
		this.#workFunctionName = props?.workFunctionName || props?.name || "";
		this.#lastChanged = props?.lastChanged || formatDate();
		this.#lastChangeAuthorId = props?.lastChangeAuthorId || null;
	}

	send = () => {
		let that = this;
		let isNew = !(this.#workFunctionId > 0);
		let prom = new Promise((resolve, reject) => {
			let req = that.sendWfunc().then(() => {
				if (isNew)
					return (that.linkToCompany());
				resolve(that.values());
				return (that.values());
			}, reject).then(() => {
				resolve (that.values());
				return (that.values());
			}, reject);
			return (req);
		});
		return (prom);
	};

	sendWfunc = () => {
		let datas = {
			companyId: this.#companyId,
			workFunctionName: this.#workFunctionName,
		};
		if (this.#workFunctionId)
			datas.workFunctionId = this.#workFunctionId;
		let req = genRequest(
			"work-functions" + (this.#workFunctionId ? "/" + this.#workFunctionId : ""),
			datas,
			(this.#workFunctionId ? "put" : "post")
		).then((resp) => {
			if (!this.#workFunctionId)
			{
				this.#companyId = resp.companyId;
				this.#workFunctionId = resp.id || resp.workFunctionId;
				this.#workFunctionName = resp.workFunctionName || resp.name;
				this.#lastChangeAuthorId = resp.lastChangeAuthorId;
				this.#lastChanged = resp.lastChanged;
			}
		});
		return (req);
	};

	linkToCompany = () => {
		let req = genRequest(
			"work-functions/" + this.#workFunctionId + "/link-company",
			{
				companyId: this.#companyId
			},
			"post"
		);
		return (req);
	};

	id = () => this.#workFunctionId;

	name = (setName) => {
		if (typeof setName !== "undefined")
			this.#workFunctionName = setName;
		return (this.#workFunctionName);
	};

	lastChanged = () => this.#lastChanged;

	lastChangeAuthorId = () => this.#lastChangeAuthorId;

	values = () => ({
		companyId: this.#companyId,
		workFunctionId: this.#workFunctionId,
		workFunctionName: this.#workFunctionName,
		lastChanged: this.#lastChanged,
		lastChangeAuthorId: this.#lastChangeAuthorId
	});
}

export default WorkFunctionObject;
